import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Input from '../common/Input';
import { format } from 'date-fns';
import { Button } from 'react-bootstrap';
import { getPaymentsByDates, getPaymentsByDatesCriteria } from '../service/paymentService';
import { getPaymentStatus } from '../service/paymentStatusService';
import subDays from 'date-fns/subDays';
import { FaSearch } from 'react-icons/fa';
import { IoMdList } from 'react-icons/io';
import DataTable from '../common/DataTable';
import { toast } from 'react-toastify';
import FilterBox from '../common/FilterBox';
import SelectBox from '../common/SelectBox';
import * as d3c from 'd3-collection';
import * as d3a from 'd3-array';
import { CSVLink } from 'react-csv';
import { isAdmin } from '../service/authService';

const PaymentHistory = () => {
   const [startDate, setStartDate] = useState(subDays(new Date(), 0));
   const [endDate, setEndDate] = useState(new Date());
   const [keyValue, setKeyValue] = useState('');
   const [keySearch, setKeySearch] = useState(null);
   const [items, setItems] = useState([]);
   const [filterValue, setFilterValue] = useState('');
   const [currentData, setCurrentData] = useState([]);
   const [paymentsStatus, setPaymentsStatus] = useState([]);
   const [selectedStatus, setSelectedStatus] = useState({});
   const role = localStorage.getItem('role');

   const options = [
      { value: '', label: '' },
      { value: 'mobile', label: 'By Mobile' },
      { value: 'meter', label: 'By Meter' },
      { value: 'transactionId', label: 'By Transaction Id' },
   ];

   let pageSize = 15;
   let recordNumber = 10;

   const exportHeaders = [
      { label: 'Transaction Id', key: 'transactionId' },
      { label: 'Phone Number', key: 'msisdn' },
      { label: 'Ext Transaction Id', key: 'externalTransactionId' },
      { label: 'Amount', key: 'paymentAmount' },
      { label: 'Status', key: 'paymentStatusId.paymentStatusName' },
      { label: 'Time', key: 'paymentDateTime' },
   ];

   const columns = [
      {
         columnCaption: 'Transaction Id',
         columnKey: 'transactionId',
         type: 'text',
         content: (item) => <Link to={`/SaleHistoryDetails/${item.transactionId}`}>{item.transactionId}</Link>,
      },
      {
         columnCaption: 'Phone Number',
         columnKey: 'msisdn',
      },
      {
         columnCaption: 'Ext Transaction Id',
         columnKey: 'externalTransactionId',
      },
      {
         columnCaption: 'Amount',
         columnKey: 'paymentAmount',
      },
      {
         columnCaption: 'Status',
         columnKey: 'paymentStatusId.paymentStatusName',
      },
      {
         columnCaption: 'Time',
         columnKey: 'paymentDateTime',
      },
   ];
   const fetchPaymentsStatus = () => {
      getPaymentStatus()
         .then((result) => {
            const statuses = [...result.data.data];
            if (statuses.length > 0) {
               fetchPayments(statuses);
            }
         })
         .catch((error) => {
            console.log(error);
         });
   };

   const fetchPayments = (paymentStatuses) => {
      let formatedStartDate = format(startDate, 'yyyy-MM-dd');
      let formatedEndDate = format(endDate, 'yyyy-MM-dd');
      getPaymentsByDates(formatedStartDate, formatedEndDate, -1).then((result) => {
         let payments = result.data.data;
         setCurrentData(payments);
         let groupedStatus = [{ key: '-1', value: { name: 'Clear All' } }, ...groupByStatus(payments)];
         setPaymentsStatus(groupedStatus);
         setItems(payments);
         setCurrentData(payments);
      });
   };

   const groupByStatus = (data) => {
      return d3c
         .nest()
         .key((d) => {
            return d.paymentStatusId.paymentStatusId;
         })
         .rollup((v) => ({
            count: v.length,
            name: v[0].paymentStatusId.paymentStatusName,
         }))
         .entries(data);
   };

   const onSelectStatus = (status) => {
      setSelectedStatus((prevState) => ({ ...prevState, ...status }));
      let searchItems = [...currentData];
      if (status.key !== '-1') {
         let filteredItems = searchItems.filter((dataItem) => {
            if (dataItem.paymentStatusId.paymentStatusId === parseInt(status.key)) return dataItem;
         });
         setItems(filteredItems);
      } else {
         setItems(searchItems);
      }
   };

   const onSearch = (e) => {
      e.preventDefault();
      let value = e.target.value;
      setFilterValue(value);
      let searchItems = [...currentData];
      let filteredItems = searchItems.filter((dataItem) => {
         if (
            dataItem.paymentAmount === value ||
            dataItem.paymentDateTime.toUpperCase().includes(value.toUpperCase()) ||
            dataItem.transactionId.toUpperCase().includes(value.toUpperCase()) ||
            dataItem.externalTransactionId.toUpperCase().includes(value.toUpperCase()) ||
            dataItem.paymentStatusId.paymentStatusName.toUpperCase().includes(value.toUpperCase()) ||
            dataItem.msisdn.toUpperCase().includes(value.toUpperCase())
         )
            return dataItem;
      });
      setItems(filteredItems);
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      let formatedStartDate = format(startDate, 'yyyy-MM-dd');
      let formatedEndDate = format(endDate, 'yyyy-MM-dd');
      if (keySearch && keyValue) {
         getPaymentsByDatesCriteria(formatedStartDate, formatedEndDate, keySearch.value, keyValue, recordNumber).then((result) => {
            let payments = result.data.data;
            if (payments.length === 0) toast.info('No Records found', { autoClose: 1500 });
            setCurrentData(payments);
            let groupedStatus = [{ key: '-1', value: { name: 'Clear All' } }, ...groupByStatus(payments)];
            setPaymentsStatus(groupedStatus);
            setItems(payments);
         });
      } else {
         getPaymentsByDatesCriteria(formatedStartDate, formatedEndDate, '', '', -1).then((result) => {
            let payments = result.data.data;
            if (payments.length === 0) toast.info('No Records found', { autoClose: 1500 });
            setCurrentData(payments);
            let groupedStatus = [{ key: '-1', value: { name: 'Clear All' } }, ...groupByStatus(payments)];
            setPaymentsStatus(groupedStatus);
            setItems(payments);
         });
      }
   };

   useEffect(fetchPaymentsStatus, []);

   return (
      <div className='container-fluid'>
         <div className='row'>
            <div className='col-lg-2 col-md-3'>
               <FilterBox
                  items={paymentsStatus}
                  selectedItem={(item) => item}
                  textProperty={(item) => item.value.name}
                  valueProperty={(item) => item.key}
                  onItemSelect={onSelectStatus}
               />
            </div>
            <div className='col-lg-10 col-md-9'>
               <div className='row'>
                  <div className='col-md-8 col-lg-6'>
                     <form className='form' onSubmit={handleSubmit}>
                        <div className='form-row align-items-center'>
                           <div className='form-group custom-form-group col-lg-4 col-md-4'>
                              <label htmlFor='startDate'>StartDate</label>
                              <Input
                                 type='date'
                                 selected={startDate}
                                 onChange={(date) => setStartDate(date)}
                                 dateFormat='dd/MM/yyyy'
                                 id='startDate'
                                 className='form-control form-control-sm custom-input'
                              />
                           </div>
                           <div className='form-group custom-form-group col-lg- col-md-4'>
                              <label htmlFor='endDate'>End Date</label>
                              <Input
                                 type='date'
                                 selected={endDate}
                                 onChange={(date) => setEndDate(date)}
                                 dateFormat='dd/MM/yyyy'
                                 id='endDate'
                                 className='form-control form-control-sm custom-input'
                              />
                           </div>
                        </div>
                        <div className='form-row'>
                           <div className='form-group col-md-4'>
                              <SelectBox
                                 label='Search By'
                                 getOptionLabel={({ label }) => label}
                                 getOptionValue={({ value }) => value}
                                 value={keySearch}
                                 options={options}
                                 onChange={(selected) => setKeySearch(selected)}
                                 placeholder={'Search By ...'}
                              />
                           </div>
                           <div className='form-group col-md-4'>
                              <input
                                 type='text'
                                 className='form-control form-control-sm custom-input'
                                 placeholder='Search Value'
                                 id='phoneNumber'
                                 value={keyValue}
                                 onChange={(e) => setKeyValue(e.target.value)}
                              />
                           </div>
                        </div>
                        <Button type='submit' className='btn btn-sm btn-custom text-white'>
                           <FaSearch /> Search
                        </Button>
                     </form>
                  </div>
               </div>
               <div className='row'>
                  <div className='col-md-12'>
                     <div className='form'>
                        <form className='form-inline justify-content-between'>
                           <div className='input-group input-group-sm mb-2 mr-sm-2'>
                              <div className='input-group-prepend'>
                                 <div className='input-group-text'>
                                    <IoMdList />
                                 </div>
                              </div>
                              <Input
                                 name='searchBox'
                                 type='text'
                                 className='form-control custom-input'
                                 id='searchBox'
                                 value={filterValue}
                                 placeholder=''
                                 onChange={onSearch}
                              />
                           </div>
                           <div>
                              {!isAdmin ? (
                                 ''
                              ) : (
                                 <CSVLink
                                    data={items}
                                    headers={exportHeaders}
                                    filename={'payments.csv'}
                                    target='_blank'
                                    className='btn-link-custom font-italic font-weight-normal'
                                 >
                                    Export CSV
                                 </CSVLink>
                              )}
                           </div>
                        </form>
                        <div className='table-responsive'>
                           <DataTable items={items} pageSize={pageSize} rowKey={'transactionId'} columns={columns}></DataTable>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default PaymentHistory;
